import axios from 'axios';
import React from 'react';

const DeleteConfirmationModal = ({url, data, message, title, ...props}) => {

    const deleteSubmited = (e) => {
        axios(url, {
            method: "DELETE",
            data: data,
        }).then(() => {
            window.location.reload();
        })
    }

    return (
        <div>
            <button type="button" className="btn btn-outline-danger" data-toggle="modal" data-target="#deleteConfidantModal">
                Видалити
            </button>

            <div className="modal fade" id="deleteConfidantModal" tabIndex="-1" role="dialog" aria-labelledby="deleteConfidantModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="deleteConfidantModalLabel">{title}</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            {message}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal">Ні</button>
                            <button type="button" onClick={deleteSubmited} className="btn btn-danger">Так</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default DeleteConfirmationModal;